import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Button } from "@mui/material";
import type { NodeKey } from "lexical";
import type { FC } from "react";
import type { PollWithOptions } from "../../../../../poll/server/supabase-poll-service";
import { EditorActionButtons } from "../../../components/button/editor-action-buttons";

export const ChatPollComponent: FC<{
  nodeKey: NodeKey;
  poll: PollWithOptions;
}> = ({ nodeKey, poll }) => {
  const [editor] = useLexicalComposerContext();
  return (
    <EditorActionButtons
      buttons={[]}
      disabled={!editor.isEditable()}
      nodeKey={nodeKey}
      data-analytics-id="lexical-button-list"
    >
      {poll.poll.options.map((button, i) => (
        <Button
          key={i}
          data-analytics-id="lexical-button-list-button-preview"
          sx={{ border: 1, p: "3px" }}
        >
          {button.text}
        </Button>
      ))}
    </EditorActionButtons>
  );
};
